const setQuestions = (state: any, questions: any) => {
  const newQuestions = questions.map((question: any) => {
    if (question.answered) {
      return { ...question, status: 'approved' }
    }

    if (!question.status) {
      return { ...question, status: 'pending' }
    }

    return question
  })

  Object.assign(state, { questions: newQuestions })
}

export default {
  setQuestions,
}
